const UNLOCK_KEY_PREFIX = 'portalUnlocked:';
const UNLOCK_DURATION_MS = 24 * 60 * 60 * 1000;

export const isPortalUnlocked = (projectId?: string): boolean => {
  if (!projectId) return false;
  const key = `${UNLOCK_KEY_PREFIX}${projectId}`;
  try {
    const expiresAt = Number(sessionStorage.getItem(key));
    if (!expiresAt || Date.now() > expiresAt) {
      sessionStorage.removeItem(key);
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

export const unlockPortal = (projectId: string): void => {
  try {
    sessionStorage.setItem(`${UNLOCK_KEY_PREFIX}${projectId}`, String(Date.now() + UNLOCK_DURATION_MS));
  } catch {
    // sessionStorage unavailable (e.g. private browsing) - unlock stays in-memory for this render only
  }
};
